// Áreas del EXANI-II (CENEVAL) usadas por la academia (cursos/lector).
//
// Los IDs numéricos corresponden al nodo `areas` de la RTDB del proyecto
// exani-6a763 y a `area_id` en `temas`:
//   1 Pensamiento matemático      12 Filosofía
//   2 Comprensión lectora         13 Física
//   3 Redacción indirecta         14 Historia
//   4 Inglés como lengua extranjera 15 Literatura
//   5 Administración              16 Matemáticas financieras
//   6 Aritmética                  17 Premedicina
//   7 Biología                    18 Probabilidad y estadística
//   8 Cálculo diferencial e integral 19 Psicología
//   9 Ciencias de la salud        20 Química
//  10 Derecho                     21 Ciencias experimentales
//  11 Economía                    22 Ciencias sociales

export const AREA_KEYS = {
  1: 'pensamiento_matematico',
  2: 'comprension_lectora',
  3: 'redaccion_indirecta',
  4: 'ingles',
  5: 'administracion',
  6: 'aritmetica',
  7: 'biologia',
  8: 'calculo',
  9: 'ciencias_salud',
  10: 'derecho',
  11: 'economia',
  12: 'filosofia',
  13: 'fisica',
  14: 'historia',
  15: 'literatura',
  16: 'matematicas_financieras',
  17: 'premedicina',
  18: 'probabilidad_estadistica',
  19: 'psicologia',
  20: 'quimica',
  21: 'ciencias_experimentales',
  22: 'ciencias_sociales',
};

export const AREA_NAMES = {
  pensamiento_matematico: 'Pensamiento Matemático',
  comprension_lectora: 'Comprensión Lectora',
  redaccion_indirecta: 'Redacción Indirecta',
  ingles: 'Inglés',
  administracion: 'Administración',
  aritmetica: 'Aritmética',
  biologia: 'Biología',
  calculo: 'Cálculo Diferencial e Integral',
  ciencias_salud: 'Ciencias de la Salud',
  derecho: 'Derecho',
  economia: 'Economía',
  filosofia: 'Filosofía',
  fisica: 'Física',
  historia: 'Historia',
  literatura: 'Literatura',
  matematicas_financieras: 'Matemáticas Financieras',
  premedicina: 'Premedicina',
  probabilidad_estadistica: 'Probabilidad y Estadística',
  psicologia: 'Psicología',
  quimica: 'Química',
  ciencias_experimentales: 'Ciencias Experimentales',
  ciencias_sociales: 'Ciencias Sociales',
};

export const areaKeyForId = (id) => AREA_KEYS[Number(id)] || `area_${id}`;

const norm = (s) => String(s || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim();

// Deriva el areaKey a partir del nombre de la categoría del curso
// (ej. "Comprensión Lectora" → "comprension_lectora").
export const areaKeyForCategory = (category) => {
  const cat = norm(category);
  if (!cat) return null;
  const entries = Object.entries(AREA_NAMES);
  const exact = entries.find(([, name]) => norm(name) === cat);
  if (exact) return exact[0];
  const match = entries.find(([, name]) => {
    const n = norm(name);
    return cat.includes(n) || n.includes(cat);
  });
  return match ? match[0] : null;
};
